
export class DownloadUserTicketsRequestDto {
  eventId: string;
  ticketOrderId?: string;
  userTicketIds?: string[];
}
